import { IUserContext } from '@truckdown/systems';
import registerLocations from '@truckdown/locations';

import './Services';
import './Images';
import './Components';
import './Styles/Locations.less';

export { LocationUtilities } from './LocationUtilities';
export * as ComponentUtilities from './Components/utilities';

export default {
    registerPrerequisites: (context: IUserContext) => {
        registerLocations(context);
    }
};
